<template>
    <div id="dashboard-page" style="margin-bottom:55px;">
        <b-card>
            <b-row>
              <b-col md="12">
              <h3>{{$route.name}}</h3>
              <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/company-structure/customer">Customer</router-link></b-breadcrumb-item>
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
              </b-breadcrumb>
              <div class="border-bottom"></div>
             </b-col>
            </b-row>
            <b-form class="mt-3 mx-2">
              <b-row>
                <b-col md="6">
                  <b-row>
                    <b-col md="4"><label class="labels">Customer ID</label></b-col>
                    <b-col md="8"><p>{{ model.customerId !== undefined && model.customerId !== null && model.customerId !== '' ? model.customerId : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">Type</label></b-col>
                    <b-col md="8"><p>{{ model.type !== undefined && model.type !== null && model.type !== '' ? model.type : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">Sales Type</label></b-col>
                    <b-col md="8"><p>{{ model.salesType !== undefined && model.salesType !== null && model.salesType !== '' ? model.salesType : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">Business Sector</label></b-col>
                    <b-col md="8"><p>{{ model.businessSector !== undefined && model.businessSector !== null && model.businessSector !== '' ? model.businessSector.name : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4" v-if="model.type === 'Company'"><label class="labels">Customer Name</label></b-col>
                    <b-col md="4" v-else><label class="labels">Customer Name</label></b-col>
                    <b-col md="8"><p>{{ model.name !== undefined && model.name !== null && model.name !== '' ? model.name : '-'}}</p></b-col>
                  </b-row>
                  <b-row v-if="model.type === 'Personal' || model.type === 'Government' && model.type === 'Company'">
                  <!-- <b-row> -->
                    <b-col md="4"><label class="labels">Gender</label></b-col>
                    <b-col md="8"><p>{{ model.gender !== undefined && model.gender !== null && model.gender !== '' ? model.gender : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">Market Segment</label></b-col>
                    <b-col md="8"><p>{{ model.marketSegment !== undefined && model.marketSegment !== null && model.marketSegment !== '' ? model.marketSegment : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">Telephone</label></b-col>
                    <b-col md="8"><p>{{ model.phone !== undefined && model.phone !== null && model.phone !== '' ? model.phone : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">Fax Number</label></b-col>
                    <b-col md="8"><p>{{ model.fax !== undefined && model.fax !== null && model.fax !== '' ? model.fax : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">Website</label></b-col>
                    <b-col md="8"><p>{{ model.website !== undefined && model.website !== null && model.website !== '' ? model.website : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">Social Media</label></b-col>
                    <b-col md="8">
                      <tbody v-if="model.socialMediaList.length > 0">
                        <tr v-for="socialMedia in model.socialMediaList" :key="socialMedia" >
                          <td>
                            <li>{{socialMedia}}</li>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="9" class="text-center">-</td>
                        </tr>
                      </tbody>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="6">
                  <b-row>
                    <b-col md="4"><label class="labels">Email</label></b-col>
                    <b-col md="8"><p>{{ model.email !== undefined && model.email !== null && model.email !== '' ? model.email : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">Tax ID</label></b-col>
                    <b-col md="8"><p>{{ model.taxId !== undefined && model.taxId !== null && model.taxId !== '' ? model.taxId : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">Address</label></b-col>
                    <b-col md="8"><p class="text-justify">{{ model.address !== undefined && model.address !== null && model.address !== '' ? model.address : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">State</label></b-col>
                    <b-col md="8"><p>{{ model.state !== undefined && model.state !== null && model.state !== '' ? model.state : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">City</label></b-col>
                    <b-col md="8"><p>{{ model.city !== undefined && model.city !== null && model.city !== '' ? model.city : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">Postal Code</label></b-col>
                    <b-col md="8"><p>{{ model.postalCode !== undefined && model.postalCode !== null && model.postalCode !== '' ? model.postalCode : '-'}}</p></b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4"><label class="labels">Description</label></b-col>
                    <b-col md="8"><p class="text-justify">{{ model.description !== undefined && model.description !== null && model.description !== '' ? model.description : '-'}}</p></b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col v-if="model.type !== 'Individual' && model.type !== 'Government'" md="12">
                  <b-row>
                    <b-col md="12">
                      <h5 class="mt-3 mb-3">Designated</h5>
                      <hr class="mt-0">
                    </b-col>
                    <b-col md="6">
                      <b-row>
                        <b-col md="4"><label class="labels">PIC Name</label></b-col>
                        <b-col md="8"><p>{{ model.picName !== undefined && model.picName !== null && model.picName !== '' ? model.picName : '-'}}</p></b-col>
                      </b-row>
                      <b-row>
                        <b-col md="4"><label class="labels">Gender</label></b-col>
                        <b-col md="8"><p>{{ model.gender !== undefined && model.gender !== null && model.gender !== '' ? model.gender : '-'}}</p></b-col>
                      </b-row>
                      <b-row>
                        <b-col md="4"><label class="labels">Phone 1</label></b-col>
                        <b-col md="8"><p>{{ model.workphone !== undefined && model.workphone !== null && model.workphone !== '' ? model.workphone : '-'}}</p></b-col>
                      </b-row>
                      <b-row>
                        <b-col md="4"><label class="labels">Phone 2</label></b-col>
                        <b-col md="8"><p>{{ model.whatsapp !== undefined && model.whatsapp !== null && model.whatsapp !== '' ? model.whatsapp : '-'}}</p></b-col>
                      </b-row>
                    </b-col>
                    <b-col md="6">
                      <b-row>
                        <b-col md="4"><label class="labels">Division</label></b-col>
                        <b-col md="8"><p>{{ model.divisionCustomer !== undefined && model.divisionCustomer !== null && model.divisionCustomer !== '' ? model.divisionCustomer : '-'}}</p></b-col>
                      </b-row>
                      <b-row>
                        <b-col md="4"><label class="labels">Position</label></b-col>
                        <b-col md="8"><p>{{ model.positionCustomer !== undefined && model.positionCustomer !== null && model.positionCustomer !== '' ? model.positionCustomer : '-'}}</p></b-col>
                      </b-row>
                      <b-row>
                        <b-col md="4"><label class="labels">Work Email</label></b-col>
                        <b-col md="8"><p>{{ model.workemail !== undefined && model.workemail !== null && model.workemail !== '' ? model.workemail : '-'}}</p></b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <h5 class="mt-3 mb-3">QR Code</h5>
                  <hr class="mt-0 mb-0">
                </b-col>
                <b-col md="12 mb-3 mt-2">
                  <b-row v-if="model.qrCode === null || model.qrCode === 'null' || model.qrCode === ''">
                    <b-col md="3">
                      <p class="text-secondary text-center border border-radius p-5"><i>No QR Code Submitted</i></p>
                    </b-col>
                  </b-row>
                  <viewer v-else>
                    <b-row>
                      <b-col md="2">
                        <b-img :src="model.qrCode" class="img-responsive" width="275" height="250"/>
                      </b-col>
                      <b-col md="2" class="printPosition">
                        <b-button style="margin-top:110px!important; margin-right:30px!important;" v-b-tooltip.hover.top title="Print QR Code" @click="doPrintQRCode()" variant="secondary" class="btn-download float-right"><font-awesome-icon icon="print"/></b-button>
                      </b-col>
                    </b-row>
                  </viewer>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-row>
                    <b-col md="12">
                      <h5 class="mt-2 mb-3">Company Group</h5>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="12">
                  <div class="table-responsive">
                    <table class="table table-hovered table-striped">
                      <thead>
                        <tr>
                          <th scope="col" class="text-center border-right" width="500">Company</th>
                          <th scope="col" width="10"></th>
                          <th scope="col" class="text-center" width="500">Branch</th>
                        </tr>
                      </thead>
                      <tbody v-if="model.customerGroupList.length > 0">
                      <tr v-for="customerGroup in model.customerGroupList" :key="customerGroup.uuid">
                        <td class="text-center border-right" width="500">{{customerGroup.company !== null ? customerGroup.company.name : '-'}}</td>
                        <td width="10"></td>
                        <td class="text-center" width="500">{{customerGroup.branch !== null ? customerGroup.branch.name : '-'}}</td>
                      </tr>
                      </tbody>
                      <tbody v-else>
                      <tr>
                          <td colspan="9" class="text-center">There's no data</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </b-col>
              </b-row>
            </b-form>
            <b-button class="mt-5" :to="'/company-structure/customer'" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
            <b-button class="mt-5 float-right" :to="'/company-structure/customer/' + $route.params.uuid + '/edit'" variant="warning"><font-awesome-icon icon="pencil-alt"></font-awesome-icon> Edit</b-button>
        </b-card>
    </div>
</template>

<script>
    import 'viewerjs/dist/viewer.css'
    import Viewer from 'v-viewer'
    import Vue from 'vue'
    Vue.use(Viewer)

    export default {
        name: 'customer-details',
        data () {
          return {
            isLoading: false,
            apiUrl: {
              customer: window.AppConfig.apiUrl + 'customer'
            },
            model: {
              type: '',
              salesType: '',
              customerId: '',
              customerCompany: {
                company: null,
                branch: ''
              },
              businessSector: '',
              status: '',
              marketSegment: '',
              website: '',
              fax: '',
              city: '',
              state: '',
              postalCode: '',
              description: '',
              taxId: '',
              taxCategory: '',
              name: '',
              gender: '',
              workphone: '',
              email: '',
              workemail: '',
              address: '',
              picName: '',
              divisionCustomer: '',
              positionCustomer: '',
              whatsapp: '',
              phone: '',
              accountNumber: '',
              accountName: '',
              bank: '',
              accountType: '',
              accountSubtype: '',
              qrCode: null,
              socialMediaList: [],
              socialMedia: '',
              customerGroupList: []
            },
          }
        },
        mounted () {
          this.getDetail()
        },
        methods: {
          getDetail () {
            this.isLoading = true
            this.$http.get(this.apiUrl.customer + '/' + this.$route.params.uuid).then(response => {
              this.model.type = response.data.type !== null && response.data.type !== 'null' ? response.data.type : '-'
              this.model.salesType = response.data.salesType !== null && response.data.salesType !== 'null' ? response.data.salesType : '-'
              this.model.customerId = response.data.customerId !== null && response.data.customerId !== 'null' ? response.data.customerId : '-'
              this.model.name = response.data.name !== null && response.data.name !== 'null' ? response.data.name : '-'
              this.model.gender = response.data.gender !== null && response.data.gender !== 'null' ? response.data.gender : '-'
              this.model.address = response.data.address !== null && response.data.address !== 'null' ? response.data.address : '-'
              this.model.phone = response.data.phone !== null && response.data.phone !== 'null' ? response.data.phone : '-'
              this.model.email = response.data.email !== null && response.data.email !== 'null' ? response.data.email : '-'
              this.model.workemail = response.data.workemail !== null && response.data.workemail !== 'null' ? response.data.workemail : '-'
              this.model.taxId = response.data.taxId !== null && response.data.taxId !== 'null' ? response.data.taxId : '-'
              this.model.taxCategory = response.data.taxCategory !== null || response.data.taxCategory !== 'null' ? response.data.taxCategory : '-'
              this.model.description = response.data.description !== null && response.data.description !== 'null' ? response.data.description : '-'
              this.model.businessSector = response.data.businessSector !== null ? response.data.businessSector : '-'
              this.model.fax = response.data.fax !== null && response.data.fax !== 'null' ? response.data.fax : '-'
              this.model.status = response.data.status !== null && response.data.status !== 'null' ? response.data.status : '-'
              this.model.marketSegment = response.data.marketSegment !== null && response.data.marketSegment !== 'null' ? response.data.marketSegment : '-'
              this.model.website = response.data.website !== null && response.data.website !== 'null' ? response.data.website : '-'
              this.model.city = response.data.city !== null && response.data.city !== 'null' ? response.data.city : '-'
              this.model.state = response.data.state !== null && response.data.state !== 'null' ? response.data.state : '-'
              this.model.postalCode = response.data.postalCode !== null && response.data.postalCode !== 'null' ? response.data.postalCode : '-'
              this.model.picName = response.data.picName !== null && response.data.picName !== 'null' ? response.data.picName : '-'
              this.model.divisionCustomer = response.data.divisionCustomer !== null && response.data.divisionCustomer !== 'null' ? response.data.divisionCustomer.name : '-'
              this.model.positionCustomer = response.data.positionCustomer !== null && response.data.positionCustomer !== 'null' ? response.data.positionCustomer.name : '-'
              this.model.whatsapp = response.data.whatsapp !== null && response.data.whatsapp !== 'null' ? response.data.whatsapp : '-'
              this.model.workphone = response.data.workphone !== null && response.data.workphone !== 'null' ? response.data.workphone : '-'
              this.model.accountNumber = response.data.accountNumber !== null && response.data.accountNumber !== 'null' ? response.data.accountNumber : '-'
              this.model.accountName = response.data.accountName !== null && response.data.accountName !== 'null'? response.data.accountName : '-'
              this.model.bank = response.data.bank !== null && response.data.bank !== 'null'? response.data.bank : '-'
              this.model.accountType = response.data.accountType !== null && response.data.accountType !== 'null'? response.data.accountType : '-'
              this.model.accountSubtype = response.data.accountSubtype !== null && response.data.accountSubtype !== 'null'? response.data.accountSubtype : '-'
              this.model.qrCode = response.data.qrCode[0].path

              this.customerGroupList = []
              if (response.data.customerCompany !== null) {
                response.data.customerCompany.forEach(data => {
                  this.model.customerGroupList.push(data)
                })
              }
              this.socialMediaList = []
              if (response.data.socialMedia !== null) {
                response.data.socialMedia.forEach(data => {
                  this.model.socialMediaList.push(data)
                })
              }
            })
          },
          doPrintQRCode () {
            var urlQrCode = this.model.qrCode
            var win = window.open('' )
            var img=win.document.createElement("img")
            img.src= urlQrCode
            win.document.body.appendChild(img)
            img.onload = function(){
              // win.open()
              win.print()
            }
          },
          getDateTime (value) {
            if (value !== null) {
              return this.$moment(value).format('DD MMM YYYY HH:mm A')
            } else {
              return '-'
            }
          },
          goBack () {
            window.goBack(this)
          },
          getStatusColor (val) {
            if (val) {
              return "success"
            } else {
              return "secondary"
            }
          },
          getStatusName (val) {
            if (val) {
              return "Headquarters"
            } else {
              return "Branch"
            }
          }
        }
    }
</script>